const config = {
  appid: 'wxfe2b81b550972404', // 微信公众号appid
}

export default config
